import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Input } from "./index";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const InputEmail = forwardRef((props, ref) => {
  const { children, ...otherProps } = props;

  return (
    <Input
      ref={ref}
      type="email"
      pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
      {...otherProps}
    >
      {children}
    </Input>
  );
});

InputEmail.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

InputEmail.displayName = "InputEmail";

export default InputEmail;
